module.exports = __webpack_public_path__ + "img/doctors.8cf6a4b9.svg";